import { Link } from "react-router-dom";
import olenaPortrait from "../../images/Olena_Seredinska.jpg";

import s from "./aboutPage.module.scss";

export const AboutPage = ({ cookieConsent, onOpenCookieSettings, t }) => {
  return (
    <section className={s.page}>
      <div className={s.contentWrapper}>
        <section className={s.introSection}>
          <p className={s.pageLabel}>{t.navigation.about}</p>
          <h1 className={s.pageTitle}>{t.about.pageTitle}</h1>
          {t.about.pageSubtitle ? (
            <p className={s.pageSubtitle}>{t.about.pageSubtitle}</p>
          ) : null}
          {t.about.intro?.map((paragraph) => (
            <p key={paragraph} className={s.introText}>
              {paragraph}
            </p>
          ))}
        </section>

        <section className={s.servicesSection}>
          <h2 className={s.sectionTitle}>{t.about.servicesTitle}</h2>
          <div className={s.servicesGrid}>
            {t.about.services.map((service) => (
              <article key={service.title} className={s.serviceCard}>
                <h3 className={s.serviceTitle}>{service.title}</h3>
                <p className={s.serviceDescription}>{service.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className={s.profileSection}>
          <div className={s.profileImageWrapper}>
            <img
              className={s.profileImage}
              src={olenaPortrait}
              alt="Olena Seredinska"
            />
          </div>
          <div className={s.profileContent}>
            <h2 className={s.sectionTitle}>{t.about.profileTitle}</h2>
            {t.about.profileSubtitle ? (
              <p className={s.profileSubtitle}>{t.about.profileSubtitle}</p>
            ) : null}
            {t.about.profileText.map((paragraph) => (
              <p key={paragraph} className={s.profileText}>
                {paragraph}
              </p>
            ))}
          </div>
        </section>

        <section className={s.companySection}>
          <h2 className={s.sectionTitle}>{t.about.companyTitle}</h2>
          <div className={s.companyGrid}>
            {t.about.companyDetails.map((detail) => (
              <div key={detail.label} className={s.companyItem}>
                <p className={s.companyLabel}>{detail.label}</p>
                {Array.isArray(detail.value) ? (
                  <div className={s.companyValueGroup}>
                    {detail.value.map((item) => (
                      <p key={item} className={s.companyValue}>
                        {item}
                      </p>
                    ))}
                  </div>
                ) : detail.mapEmbedSrc && cookieConsent === "accepted" ? (
                  <div className={s.mapPreviewWrapper}>
                    <a
                      className={`${s.companyValue} ${s.mapPreviewTrigger}`}
                      href={detail.mapLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {detail.value}
                    </a>
                    <div className={s.mapPreview}>
                      <iframe
                        className={s.mapFrame}
                        title={detail.label}
                        src={detail.mapEmbedSrc}
                        loading="lazy"
                      />
                    </div>
                  </div>
                ) : detail.mapEmbedSrc ? (
                  <div className={s.mapConsentWrapper}>
                    <a
                      className={`${s.companyValue} ${s.mapPreviewTrigger}`}
                      href={detail.mapLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {detail.value}
                    </a>
                    <p className={s.mapConsentText}>{t.legal.mapConsentNotice}</p>
                    <button
                      className={s.mapConsentButton}
                      type="button"
                      onClick={onOpenCookieSettings}
                    >
                      {t.footer.cookieSettings}
                    </button>
                  </div>
                ) : (
                  <p className={s.companyValue}>{detail.value}</p>
                )}
              </div>
            ))}
          </div>
        </section>

        <section className={s.contactSection}>
          <h2 className={s.sectionTitle}>{t.about.contactTitle}</h2>
          <p className={s.contactQuestion}>{t.about.contactQuestion}</p>
          <p className={s.contactText}>{t.about.contactText}</p>
          <Link className={s.contactButton} to="/#formTitle">
            {t.about.contactButton}
          </Link>
        </section>
      </div>
    </section>
  );
};
